import React from "react";
import { Row, Col } from "react-bootstrap";
import { Navbar, Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ParentCategory from "../components/menus/parent-category";
const HeaderCategories = ({ scroll, categoryList, wishListCount, offCanvasShow, user, token, setLoginModalShow }) => {
    return (
        <Row className={`chRow ${scroll ? "sticky" : ""}`}>
            <Navbar collapseOnSelect expand="lg" className="p-0">
                <Col className="px-5 px-xl-2">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav
                            fill
                            className="flex-grow-1 justify-content-evenly fw-bold category-menu"
                        >
                            {categoryList && categoryList.data.map((category) => (
                                <ParentCategory items={category} key={category.categoryID} />
                            ))}

                            <div className="Hnavlink p-2">
                                {!user || !token ? (
                                    <Nav.Link
                                        className="Hmonthlisttxt text-theme-green"
                                        onClick={() => setLoginModalShow(true)}
                                    >
                                        <FontAwesomeIcon icon="fa-solid fa-heart " />
                                        &nbsp;&nbsp;
                                        <span>Monthly List </span>
                                    </Nav.Link>
                                ) : (
                                    <NavLink
                                        href="/profile/monthly-list"
                                        className="Hmonthlisttxt text-theme-green text-decoration-none"
                                    >
                                        <FontAwesomeIcon icon="fa-solid fa-heart " />
                                        &nbsp;&nbsp;
                                        <span>Monthly List ({wishListCount}) </span>
                                    </NavLink>
                                )}
                            </div>
                            <div className="Hnavlink p-2">
                                <Nav.Link
                                    href="/offers"
                                    className="Hmonthlisttxt text-theme-red"
                                >
                                    <FontAwesomeIcon icon="fa-solid fa-bullhorn bg-danger" />
                                    &nbsp;&nbsp;
                                    <span>Offers </span>
                                </Nav.Link>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Col>
            </Navbar>
        </Row>
    );
};

export default HeaderCategories;
